import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BadgeOverlap from './BadgeOverlap';
import ClientProvider from './client';
export default createDemo(import.meta.url, BadgeOverlap, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/badges/demos/overlap/BadgeOverlap.tsx",
    "fileName": "BadgeOverlap.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Badge from '@mui/material/Badge';\n\nconst shapeSize = 32;\n\nexport default function BadgeOverlap() {\n  return (\n    <Stack spacing={3} direction=\"row\">\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Badge color=\"secondary\" badgeContent={1}>\n        <Rectangle />\n      </Badge>\n      <Badge color=\"secondary\" variant=\"dot\">\n        <Rectangle />\n      </Badge>\n      <Badge color=\"secondary\" overlap=\"circular\" badgeContent={1}>\n        <Circle />\n      </Badge>\n      <Badge color=\"secondary\" overlap=\"circular\" variant=\"dot\">\n        <Circle />\n      </Badge>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n\nfunction Rectangle() {\n  return (\n    <Box\n      component=\"span\"\n      sx={{ bgcolor: 'primary.main', width: shapeSize, height: shapeSize }}\n    />\n  );\n}\n\nfunction Circle() {\n  return (\n    <Box\n      component=\"span\"\n      sx={{\n        bgcolor: 'primary.main',\n        width: shapeSize,\n        height: shapeSize,\n        borderRadius: '50%',\n      }}\n    />\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 47,
        "focusedLines": 12,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport Stack from '@mui/material/Stack';\nimport Badge from '@mui/material/Badge';\n\nconst shapeSize = 32;\n\nexport default function BadgeOverlap() {\n  return (\n    <Stack spacing={3} direction=\"row\">\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Badge color=\"secondary\" badgeContent={1}>\n        <Rectangle />\n      </Badge>\n      <Badge color=\"secondary\" variant=\"dot\">\n        <Rectangle />\n      </Badge>\n      <Badge color=\"secondary\" overlap=\"circular\" badgeContent={1}>\n        <Circle />\n      </Badge>\n      <Badge color=\"secondary\" overlap=\"circular\" variant=\"dot\">\n        <Circle />\n      </Badge>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n\nfunction Rectangle() {\n  return (\n    <Box\n      component=\"span\"\n      sx={{ bgcolor: 'primary.main', width: shapeSize, height: shapeSize }}\n    />\n  );\n}\n\nfunction Circle() {\n  return (\n    <Box\n      component=\"span\"\n      sx={{\n        bgcolor: 'primary.main',\n        width: shapeSize,\n        height: shapeSize,\n        borderRadius: '50%',\n      }}\n    />\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Badge"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "secondary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "badgeContent"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Rectangle"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Badge"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Badge"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "secondary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "dot",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Rectangle"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Badge"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Badge"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "secondary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "overlap"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "circular",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "badgeContent"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Circle"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Badge"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Badge"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "secondary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "overlap"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "circular",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "dot",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Circle"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Badge"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 47,
    "focusedLines": 12,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/Stack",
      "@mui/material/Badge"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
